'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);

/**
 * module
 */
import { fitimg } from './module/_fitimg';
import { hover } from './module/_hover';
import { responsive } from './module/_responsive';
import { inview } from './module/_inview';
import { scrSection } from './module/_scrSection';
// import { particle } from './module/_particle';
// import { paper } from './module/_paper';
import { app } from './module/_app';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(() => {
            $('body').addClass('is-loaded is-loaded-first');
        }, 250);
    };

    /**
     * init
     */
    const init = () => {
        fitimg.init();
        hover.init();
        responsive.init();
        inview.init();
        scrSection.init();
        // particle.init();
        // paper.init();

        app.init();

        $('.js-scrBtn').on('click', function () {
            $.scrollify.next();
        });

        $('.js-stBtn').on('click', function () {
            $('body').removeClass('is-scrActive');
            setTimeout(() => {
                $('body').removeClass('is-loaded');
                $.scrollify.destroy();
            }, 100);
        });
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {

    window.addEventListener('popstate', () => {
        $('body').removeClass('is-loaded');
        setTimeout(() => {
            location.reload();
        }, 100);
    });

    if (window.name != "loaded") {
        location.reload();
        window.name = "loaded";
    }

    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
